const isValidEmail = (email) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase());
};

const validPasswordConditions =
  'Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character';

const isValidPassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);

  return (
    password.length >= minLength &&
    hasUpperCase &&
    hasLowerCase &&
    hasNumbers &&
    hasNonalphas
  );
};

// Basic mobile number validation
// Accepts formats with optional country code, spaces, dashes or parentheses
const isValidMobile = (mobile) => {
  // Remove all non-digit characters for validation
  const digitsOnly = mobile.replace(/\D/g, '');
  // Check if we have a reasonable number of digits (7-15 is typical for global phone numbers)
  return digitsOnly.length >= 7 && digitsOnly.length <= 15;
};

export {
  isValidEmail,
  isValidPassword,
  isValidMobile,
  validPasswordConditions,
};
